import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { MapContext } from 'context/Map/context';
import { MapActions, MapState } from 'context/Map/types';
import { logException } from 'helpers/errors/logException';
import { Dispatch, useContext } from 'react';

export const useMapContext = (): [MapState, Dispatch<MapActions>] => {
    const mapContext = useContext(MapContext);
    const { mapSetting: defaultSetting } = useDomainConfig();

    if (!mapContext) {
        logException('MapContext is not available');

        return [
            {
                center: { lat: defaultSetting.latitude, lng: defaultSetting.longitude },
                zoom: defaultSetting.zoom,
                isFitToBounds: true,
                initSetting: defaultSetting,
            },
            () => null,
        ];
    }

    return mapContext;
};
